<template>
  <div class="c-item-list-heading">
    <span class="c-item-list-heading__title">{{ title }}</span>
    <span class="c-item-list-heading__title_en">{{ titleEn }}</span>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
	props: {
	  title: { type: String, required: true },
	  titleEn: { type: String, required: true }
    }
})
export default class ItemListHeading extends Vue {
  title!: string;
  titleEn!: string;
}
</script>

<style lang="scss" scoped>
.c-item-list-heading {
  &__title {
    @include text__title--l;
    display: block;

    @include sp {
      @include text__title--m;
    }
  }

  &__title_en {
    @include text__title--m;
    color: $common-gray500;
    display: block;
    margin-top: rem(4);

    @include sp {
      @include text__body--l;
    }
  }
}
</style>
